/* ==========================================================
   eup-collection-grid-woprice.js
   eup-collection-grid.js の「価格非表示」版。
   両ファイルは別ファイル・別クラス名として共存させる想定で、
   eup-collection-grid.js（class="eup-collection-grid"）は
   従来通り価格を表示するバージョンとして変更せずに残す。
   価格を出したくないコレクション（卒団記念グッズなど）の記事では
   本ファイル（class="eup-collection-grid-woprice"）を使う。

   設置手順:
   1. Shopify管理画面 > オンラインストア > テーマ > 「…」 > コードを編集
   2. 左メニュー Assets（アセット）で「新しいアセットを追加」
      → このファイルをアップロード（ファイル名: eup-collection-grid-woprice.js）
   3. Layout の theme.liquid を開き、</body> の直前、
      eup-collection-grid.js の <script> タグの下に以下を追加:
        <script src="{{ 'eup-collection-grid-woprice.js' | asset_url }}" defer></script>
      （eup-collection-grid.js の <script> タグは残したまま、行を追加するだけ）
   4. 価格を表示したくないブログ記事の本文（HTMLで編集）には、
      下記のように class="eup-collection-grid-woprice" のdivを置く:
        <div class="eup-collection-grid-woprice eup-handle-goods-for-graduation eup-max-8">
          <p class="eup-collection-loading">商品を読み込み中です…</p>
        </div>
      ※price版と同じ内容の記事で価格ありにしたい場合は、
        class を eup-collection-grid に変えるだけで price版（eup-collection-grid.js）に切り替わる
      ※<script>は記事側には一切書かない

   コレクションのハンドル・最大表示件数の指定方法について:
   Shopifyのブログ記事編集画面（HTMLで編集）は保存時に、独自のdata-*属性を
   自動的に削除してしまうため（<script>が消えるのと同じ、編集画面側の
   サニタイズ仕様）、handle・最大件数は class名 に埋め込む方式にしている。
     - コレクションのハンドル: class="eup-handle-{ハンドル名}"
     - 最大表示件数:           class="eup-max-{数字}"
   例: class="eup-collection-grid-woprice eup-handle-goods-for-graduation eup-max-8"
   （後方互換のため data-collection-handle / data-max-items 属性が存在すれば
   そちらを優先して読み取るが、記事側では基本的にclass名の方式を使う）

   表示件数について:
   Shopify公開APIが返す件数（＝実店舗ページに表示される件数）をそのまま
   全件表示する。管理画面上の登録商品数と、Online Storeチャネルに
   公開されている商品数は一致しないことがある（下書き・非公開商品は
   公開APIに含まれないため、実店舗ページ自体にも表示されない）。

   価格表示について:
   カード上には価格を一切表示しない（本ファイルの目的そのもの）。
   SALEバッジのみ、compare_at_price（元価格）が現在価格より高いかどうかの
   内部比較で判定して残す（数値そのものは画面に出さない）。
   SALEバッジ自体も不要な場合は onSale 関連の行ごと削除すること。

   UI再現について（参考: shophub-engager-selftraining / lp-practice）:
   公開JSON（products.json）から取得できる範囲でできるだけ近づけている。
   - SALEバッジ: compare_at_price（元価格）が現在価格より高い場合に表示
   - カラーバリエーション数: 商品オプションに「カラー/色/Color」を含む
     選択肢があれば「+N色」を表示（現在の画像以外の残り数）
   - レビュー星評価・「残りわずか」の在庫数表示は、公開JSONに該当データが
     含まれていないため再現していない
   - 売り切れ（SOLD OUT）表示はあえて実装していない（在庫・購入可否の
     概念自体が存在しない紹介用コレクションを想定しているため）

   表示件数の上限について:
   class="eup-max-{数字}" で1回に表示する最大件数を指定できる
   （未指定時は既定で8件）。実際の商品数がこれを超える場合は、
   グリッドの下に「すべて見る（◯件）」というボタンを自動で追加し、
   そのコレクションの実ページ（/collections/{handle}）に遷移する。

   デバッグログについて:
   冒頭の DEBUG を true にすると、ブラウザのConsoleに動作ログが出る。
   本番公開時は false のままにすること。
   ========================================================== */
(function () {
  // 動作確認用ログの出し分け。本番公開時はfalseのままにする。
  var DEBUG = false;

  function log() {
    if (DEBUG && window.console && console.log) console.log.apply(console, arguments);
  }

  function warn() {
    if (DEBUG && window.console && console.warn) console.warn.apply(console, arguments);
  }

  function logError() {
    if (DEBUG && window.console && console.error) console.error.apply(console, arguments);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getColorOptionCount(product) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var name = String(options[i].name || '');
      if (/color|カラー|色/i.test(name)) {
        return (options[i].values || []).length;
      }
    }
    return 0;
  }

  // 配列の並び順に依存せず、最安値のバリアントを返す
  // （SALEバッジの判定にのみ使用。価格そのものは画面に出さない）
  function getMinPriceVariant(product) {
    var variants = product.variants || [];
    if (!variants.length) return {};
    return variants.reduce(function (min, v) {
      var vPrice = Number(v.price);
      var minPrice = Number(min.price);
      if (isNaN(minPrice) || (!isNaN(vPrice) && vPrice < minPrice)) return v;
      return min;
    }, variants[0]);
  }

  // data-*属性はShopifyの記事保存時に削除されることがあるため、
  // class名からも handle / maxItems を読み取れるようにする。
  function parseGridConfig(grid) {
    var handle = grid.getAttribute('data-collection-handle') || null;
    var maxItemsAttr = grid.getAttribute('data-max-items');
    var maxItems = maxItemsAttr !== null ? parseInt(maxItemsAttr, 10) : null;

    var classes = (grid.className || '').split(/\s+/);
    classes.forEach(function (cls) {
      if (!handle && cls.indexOf('eup-handle-') === 0) {
        handle = cls.slice('eup-handle-'.length);
      }
      if ((maxItems === null || isNaN(maxItems)) && cls.indexOf('eup-max-') === 0) {
        var n = parseInt(cls.slice('eup-max-'.length), 10);
        if (!isNaN(n)) maxItems = n;
      }
    });

    if (maxItems === null || isNaN(maxItems) || maxItems < 0) maxItems = 12;
    return { handle: handle, maxItems: maxItems };
  }

  function renderGrid(container, handle, maxItems) {
    log('[eup-collection-grid-woprice] fetch開始:', '/collections/' + handle + '/products.json?limit=250');
    fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var allProducts = (data && data.products) || [];
        log('[eup-collection-grid-woprice] 取得商品数:', allProducts.length, 'handle:', handle, 'maxItems:', maxItems);
        if (!allProducts.length) {
          container.innerHTML = '<p class="eup-collection-empty">現在表示できる商品がありません。</p>';
          return;
        }

        var totalCount = allProducts.length;
        var products = maxItems > 0 ? allProducts.slice(0, maxItems) : allProducts;

        var html = products.map(function (p) {
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          var variant = getMinPriceVariant(p);
          var colorCount = getColorOptionCount(p);

          // 価格は表示しない。SALEバッジの判定にのみ内部で数値比較を使う
          // （画面には数値を一切出力しない）。
          var priceNum = Number(variant.price);
          var compareNum = variant.compare_at_price ? Number(variant.compare_at_price) : null;
          var onSale = !!(compareNum && !isNaN(priceNum) && compareNum > priceNum);

          var badgesHtml = onSale
            ? '<span class="eup-collection-badge eup-collection-badge--sale">SALE</span>'
            : '';

          var colorHtml = colorCount > 1
            ? '<p class="eup-collection-card-color">+' + (colorCount - 1) + '色</p>'
            : '';

          return (
            '<a href="' + escapeHtml('/products/' + p.handle) + '" class="eup-collection-card">' +
              '<div class="eup-collection-card-img">' +
                (badgesHtml ? '<div class="eup-collection-badges">' + badgesHtml + '</div>' : '') +
                (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
              '</div>' +
              '<p class="eup-collection-card-title">' + escapeHtml(p.title) + '</p>' +
              colorHtml +
            '</a>'
          );
        }).join('');

        container.innerHTML = html;

        // 表示件数が上限を超えている場合は「すべて見る」リンクをグリッドの下に追加
        var existingMore = container.parentNode ? container.parentNode.querySelector('.eup-collection-more[data-for="' + handle + '"]') : null;
        if (existingMore) existingMore.parentNode.removeChild(existingMore);

        if (maxItems > 0 && totalCount > maxItems) {
          var moreWrap = document.createElement('div');
          moreWrap.className = 'eup-collection-more';
          moreWrap.setAttribute('data-for', handle);
          // DETAILボタン（#455A64）と同じ見た目のボタンとして表示
          moreWrap.innerHTML =
            '<a href="/collections/' + escapeHtml(handle) + '" class="eup-btn eup-btn--detail">' +
              'すべて見る（' + totalCount + '件）' +
            '</a>';
          container.parentNode.insertBefore(moreWrap, container.nextSibling);
        }
      })
      .catch(function (err) {
        container.innerHTML = '<p class="eup-collection-empty">商品の読み込みに失敗しました。時間をおいて再度お試しください。</p>';
        logError('[eup-collection-grid-woprice]', err);
      });
  }

  function init() {
    log('[eup-collection-grid-woprice] init実行');
    var grids = document.querySelectorAll('.eup-collection-grid-woprice');
    log('[eup-collection-grid-woprice] .eup-collection-grid-woprice 要素数:', grids.length);
    grids.forEach(function (grid) {
      var config = parseGridConfig(grid);
      log('[eup-collection-grid-woprice] handle:', config.handle, 'maxItems:', config.maxItems);
      if (config.handle) {
        renderGrid(grid, config.handle, config.maxItems);
      } else {
        warn('[eup-collection-grid-woprice] コレクションのハンドルが見つかりません（class="eup-handle-xxx" が付いているか確認してください）');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();